import type { ThemeConfig } from 'antd';
import {
    buttonDark,
    buttonLite, inputDark, inputLite,
    menuDark,
    menuLite,
    tableDark,
    tableLite,
    tagDark,
    tagLite
} from "./components";
import {AliasToken} from "antd/es/theme/interface";

const tokenDefault: Partial<AliasToken> = {
    fontFamily: 'SFProText',
    fontSize: 13,
    colorPrimary: 'rgba(255, 183, 77, 1)',
    colorLink: 'rgba(255, 183, 77, 1)',
    colorLinkActive: 'rgba(255, 183, 77, 1)',
    colorLinkHover: 'rgba(255, 183, 77, 1)',
    linkDecoration: 'underline',
    linkFocusDecoration: 'underline',
    linkHoverDecoration: 'underline',
    zIndexPopupBase: 9999,
    colorBgMask: 'rgba(0, 0, 0, 0.1)',
}

export const gutter = [24, 0]

export const themeLite: ThemeConfig = {
    token: {
        ...tokenDefault,
        colorTextBase: 'rgba(48, 37, 21, 1)',
    },
    components: {
        Button: buttonLite,
        Table: tableLite,
        Menu: menuLite,
        Tag: tagLite,
        Input:{
            ...inputLite,
            activeBorderColor: tokenDefault.colorPrimary,
        },
    },
};

export const themeDark: ThemeConfig = {
    token: {
        ...tokenDefault,
    },
    components: {
        Button: buttonDark,
        Table: tableDark,
        Menu: menuDark,
        Tag: tagDark,
        Input:{
            ...inputDark,
            activeBorderColor: tokenDefault.colorPrimary,
        }
    },
};


